import init from './init';
import modalSection from './sections/modal';
import headerSection from './sections/header';
// import locoScroll from "./sections/locoScroll";
import barbaSetup from './sections/barba';

init();
// locoScroll();
barbaSetup();
modalSection();
headerSection();



// WEBPACK FOOTER //
// ./source/scripts/main.js